import React, { FC } from 'react';

import Topics from '../../../components/CollapsibleLists/Topics';
import DashboardLink from '../../../components/Dashboard/Link';
import TopicsNavigation from '../../../components/Navigation/Topics';
import SmartViews from '../../../containers/smartViews';
import { TopicsListQuery } from '../../../generated/graphql';
import useIsMobile from '../../../hooks/useIsMobile';
import { getCanViewDashboard } from '../../../utils/permissions/dashboard';

import ButtonTopicCreate from './ButtonTopicCreate';

import * as Styled from './styled';

export type Props = {
  getUrlCreate: string | null;
  isLoading: boolean;
  topics: TopicsListQuery['topics'];
};

/**
 * Shows a content for leftSidebarFeed component (TopicList, ButtonTopicCreate and SmartViews)
 *
 * @param props              props passed to the component
 * @param props.getUrlCreate Get the topic creation url (null if the user isn't allowed to create topics)
 * @param props.isLoading    Whether the topics are being fetched
 * @param props.topics       List of all topics
 * @returns                  The component itself
 */
const LeftSidebarFeedContent: FC<Props> = ({
  getUrlCreate,
  isLoading,
  topics,
}) => {
  const isMobile = useIsMobile();
  const shouldShowDashboardLink = getCanViewDashboard();

  if (isMobile === false) {
    return <TopicsNavigation isLoading={isLoading} topics={topics} />;
  }

  return (
    <Styled.Wrapper>
      {shouldShowDashboardLink && <DashboardLink />}
      <Topics isLoading={isLoading} topics={topics} />
      <ButtonTopicCreate getUrlCreate={getUrlCreate} />
      <SmartViews />
    </Styled.Wrapper>
  );
};

export default LeftSidebarFeedContent;
